"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ProductReviewsRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function ProductReviewsRenderHandler(validateSkuResponse) {
    var _this;
    (0, _classCallCheck2["default"])(this, ProductReviewsRenderHandler);
    _this = _callSuper(this, ProductReviewsRenderHandler);
    _this.pre.push(function () {
      _this.enabled = validateSkuResponse.isReviewsSkuEnabled;
      _this.asin = validateSkuResponse.asin;
      _this.roaInstanceId = validateSkuResponse.roaInstanceId;
      _this.customization = validateSkuResponse.reviewsCustomization;
      _this.linkSelector = window.reviews && window.reviews.linkSelector || "";
      _this.rfaReviewsContainerId = _constants.BWA_WIDGET_CONTAINER_IDS.BWA_RFA_REVIEWS_CONTAINER_ID;
      _this.tag = 'amazon-product-reviews';
    });
    return _this;
  }
  (0, _inherits2["default"])(ProductReviewsRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(ProductReviewsRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.render();
            case 2:
              this.setupEventListeners();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "validateAndRerender",
    value: function () {
      var _validateAndRerender = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(validateSkuResponseAfterVariantChange) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.enabled = validateSkuResponseAfterVariantChange.isReviewsSkuEnabled;
              this.asin = validateSkuResponseAfterVariantChange.asin;
              this.roaInstanceId = validateSkuResponseAfterVariantChange.roaInstanceId;
              this.customization = validateSkuResponseAfterVariantChange.reviewsCustomization;
              this.clearProductReviewsTag();
              this.render();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function validateAndRerender(_x) {
        return _validateAndRerender.apply(this, arguments);
      }
      return validateAndRerender;
    }()
  }, {
    key: "clearProductReviewsTag",
    value: function () {
      var _clearProductReviewsTag = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var productReviewsTags;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              productReviewsTags = (0, _utils.safeGetElementsByTagName)(this.tag);
              while (productReviewsTags.length > 0) {
                productReviewsTags[0].remove();
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function clearProductReviewsTag() {
        return _clearProductReviewsTag.apply(this, arguments);
      }
      return clearProductReviewsTag;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.enabled) {
                this.injectProductReviewsTag();
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "injectProductReviewsTag",
    value: function injectProductReviewsTag() {
      var reviewsTag = document.createElement(this.tag);
      if (reviewsTag) {
        reviewsTag.setAttribute('product-id', this.asin);
        if (this.customization) {
          var _this$customization$i, _this$customization$i2;
          reviewsTag.setAttribute('show-product-insights', (_this$customization$i = this.customization.isProductInsightsEnabled) !== null && _this$customization$i !== void 0 ? _this$customization$i : 'false');
          reviewsTag.setAttribute('show-gallery', (_this$customization$i2 = this.customization.isMediaGalleryEnabled) !== null && _this$customization$i2 !== void 0 ? _this$customization$i2 : 'false');
          reviewsTag.setAttribute('font-family', this.customization.fontFamily);
          reviewsTag.setAttribute('button-border-width', this.customization.buttonBorderWidth);
          reviewsTag.setAttribute('reviews-per-page', this.customization.reviewsPerPage);
          reviewsTag.setAttribute('color-mode', this.customization.colorMode);
          reviewsTag.setAttribute('corner-style', this.customization.cornerStyle);
          reviewsTag.setAttribute('is-background-transparent', this.customization.isBackgroundTransparent);
          reviewsTag.setAttribute('button-accent-color', this.customization.buttonAccentColor);
          reviewsTag.setAttribute('link-color', this.customization.linkColor);
          reviewsTag.setAttribute('layout', this.customization.layout);
        }
      }
      (0, _utils.insertElementWithFallback)(this.rfaReviewsContainerId, reviewsTag, this.linkSelector);
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.VARIANT_UPDATED, /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(event) {
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this2.validateAndRerender(event.detail.validateSkuResponse);
              case 2:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=product-reviews-render-handler.js.map
